export default __webpack_public_path__ + "static/media/user-pics-9.97669257.png";